import { Injectable } from '@angular/core';
import { Gateway, SquareLocationProduction } from '../store/gateway.models';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    constructor() {}

    adaptGatewayData(gateways: any[]): Gateway[] {
        return gateways.map((gateway) => this.adaptSingleGatewayData(gateway));
    }

    adaptSingleGatewayData(data: any): Gateway {
        // console.log('Adapting gateway data:', data); // Debug log
        const newGateway: Gateway = {
            id: data.gateway?.id || data.id || data.gateway_id,
            name: data.gateway?.name || data.name || data.gateway_name,
            type: {
                id: data.gateway?.gateway_type_id || data.gateway_type.id,
                name: data.gateway?.gateway_type_name || data.gateway_type.name,
            },
            account: {
                accessToken: data.account?.access_token,
                applicationId: data.account?.application_id,
                environment: data.account?.environment,
                id: data.account?.id,
                merchantId: data.account?.merchant_id,
            },
            squareLocationProductions: data.square_location_productions?.map(
                (acc: any): SquareLocationProduction => ({
                    id: acc.id,
                    production: {
                        id: acc.production_id,
                        name: acc.production_name,
                    },
                    location: {
                        id: acc.square_location_id,
                        name: acc.square_location_name,
                    },
                })
            ),
        };

        return newGateway;
    }
}
